import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import axios from 'axios';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container } from '@material-ui/core';

import { Loading } from '../stories/Loading';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const SummaryTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 20,
    border: 2,
    borderColor: theme.palette.common.black,
    borderStyle: 'solid',
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    textAlign: 'start',
    margin: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
  componentTitle: {
    color: '#142966',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '24px',
    marginBottom: '0px',
  },
  separatorLine: {
    height: '2px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
    background: '#004878',
    border: 'none',
  },
  table: {
    minWidth: 650,
  },
  button: {
    maxWidth: '320px',
    width: '100%',
    marginBottom: '24px',
    marginTop: '24px',
    alignSelf: 'center',
  },
}));

interface CreditListDetailsProps {}

const CreditListDetails = (props: CreditListDetailsProps) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [creditList, setCreditList] = useState<[any]>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await axios.get(`/api/getCreditList`);
        console.log(response.data);
        setCreditList(response.data);
        setError(undefined);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <Loading />
      </div>
    );
  } else if (error) {
    return <div>{error}</div>;
  } else {
    return (
      <div className={classes.root}>
        <h2 className={classes.componentTitle}>Credit List</h2>
        <hr className={classes.separatorLine} />

        <Container
          maxWidth="lg"
          style={{
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <SummaryTableCell>B No</SummaryTableCell>
                  <SummaryTableCell>B Date</SummaryTableCell>
                  <SummaryTableCell>Address</SummaryTableCell>
                  <SummaryTableCell>Due Amount</SummaryTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {creditList &&
                  creditList.map((item) => {
                    return (
                      <StyledTableRow key={item.bill_id}>
                        <StyledTableCell component="th" scope="row">
                          {item.billId}
                        </StyledTableCell>
                        <StyledTableCell>
                          {item.billDate.substring(0, 10)}
                        </StyledTableCell>
                        <StyledTableCell>{item.address}</StyledTableCell>
                        <StyledTableCell>{item.dueAmount}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>

        {/* <Container
          maxWidth="lg"
          style={{
            marginTop: '24px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <p
            style={{
              fontSize: '1.2rem',
              textDecoration: 'underline',
              marginBottom: '8px',
            }}
          >
            Today's Summary
          </p>
          {advanceSummary &&
            Object.keys(advanceSummary).map((key) => (
              <p
                style={{
                  fontSize: '1.2rem',
                  marginBottom: '8px',
                  marginTop: '8px',
                }}
              >
                {key} : {advanceSummary[key]}
              </p>
            ))}
        </Container> */}
      </div>
    );
  }
};

export default CreditListDetails;
